import { useQuery } from "@tanstack/react-query";

import { readProjectReadComment } from "../../../services/projects";
import { TReadProjectCommentResponse } from "../../../services/projects/read-project-read-comment";

type ReadBudgetCommentParams = {
    projectId: string;
};

export function useReadProjectComment({ projectId }: ReadBudgetCommentParams) {
    return useQuery<
        TReadProjectCommentResponse,
        unknown,
        TReadProjectCommentResponse
    >({
        enabled: true,
        queryKey: [`project/${projectId}/comment`],
        queryFn: () => readProjectReadComment({ projectId }),
        refetchOnMount: "always",
        refetchOnWindowFocus: false,
        refetchIntervalInBackground: false,
    });
}
